import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Aside = styled.aside`
  flex-basis: 312px;
`;

export const Report = styled.div`
  flex-basis: 800px;
`;
